export default "__VITE_ASSET__klYB_Jk5__"